import axios from "axios";

export const sendAutomaticRegistrationRequest = async (registrationUserName, registrationEmail) => {
    try {
        const {data} = await axios.post("/api/email/sendAutomaticRegistrationRequest", {registrationUserName, registrationEmail});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const sendManualRegistrationRequest = async (usernameForLoggedInUser, registrationUserName, registrationEmail) => {
    try {
        const {data} = await axios.post("/api/email/sendManualRegistrationRequest", {usernameForLoggedInUser, registrationUserName, registrationEmail});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
